import type { ReactElement } from 'react';
import { Route, Routes } from 'react-router-dom';
import { RequireSession } from './components/RequireSession.js';
import { AuditPage } from './pages/AuditPage.js';
import { DevicesPage } from './pages/DevicesPage.js';
import { LoginPage } from './pages/LoginPage.js';
import { MediaPage } from './pages/MediaPage.js';
import { NotFoundPage } from './pages/NotFoundPage.js';
import { OverviewPage } from './pages/OverviewPage.js';
import { PlaylistsPage } from './pages/PlaylistsPage.js';
import { ScreensPage } from './pages/ScreensPage.js';
import { StoresPage } from './pages/StoresPage.js';

export function App(): ReactElement {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Everything below the gate renders inside the app shell. */}
      <Route element={<RequireSession />}>
        <Route index element={<OverviewPage />} />
        <Route path="stores" element={<StoresPage />} />
        <Route path="screens" element={<ScreensPage />} />
        <Route path="media" element={<MediaPage />} />
        <Route path="playlists" element={<PlaylistsPage />} />
        <Route path="devices" element={<DevicesPage />} />
        <Route path="audit" element={<AuditPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
